document.addEventListener('click',function(e){const b=e.target.closest('[data-sf-zoom-purchase]');if(!b)return;const dialog=b.closest('dialog');if(dialog?.open)dialog.close();if(window.matchMedia('(min-width:990px) and (pointer:fine)').matches&&window.sfScrollToPurchaseOverview?.()){return;}if(window.matchMedia('(min-width:990px) and (pointer:fine)').matches){const el=document.querySelector('.sf-product .sf-review-teaser')||document.querySelector('#sf-direct-purchase');const h=document.querySelector('[data-sf-header]')?.getBoundingClientRect().height||0;if(el)requestAnimationFrame(()=>window.scrollTo({top:Math.max(0,window.scrollY+el.getBoundingClientRect().top-h-22),behavior:'smooth'}));}else document.querySelector('#sf-direct-purchase')?.scrollIntoView({behavior:'smooth',block:'center'});});document.addEventListener('click',function(e){const b=e.target.closest('[data-sf-zoom-open],[data-sf-gallery-open]');if(!b)return;setTimeout(()=>{const c=document.querySelector('[data-sf-book-zoom] [data-sf-zoom-purchase]');if(c)c.hidden=false;},150);});

(() => {
  const policyTitles = {
    'terms-of-service': 'Allgemeine Geschäftsbedingungen',
    'contact-information': 'Kontaktinformationen',
    'refund-policy': 'Widerrufsrecht',
    'shipping-policy': 'Versandinformationen',
    'privacy-policy': 'Datenschutzerklärung',
    'legal-notice': 'Impressum'
  };
  const policy = location.pathname.match(/\/policies\/([^/]+)\/?$/)?.[1];
  const heading = document.querySelector('.shopify-policy__title h1');
  if (heading && Object.hasOwn(policyTitles, policy)) heading.textContent = policyTitles[policy];

  const desktop = window.matchMedia('(min-width: 990px) and (pointer: fine)');
  document.querySelectorAll('[data-sf-copy-faq-email]').forEach(button => {
    const update = () => { button.hidden = true; };
    desktop.addEventListener('change', update);
    update();
    button.addEventListener('click', async () => {
      const address = button.dataset.sfCopyFaqEmail;
      const status = button.nextElementSibling;
      try {
        await navigator.clipboard.writeText(address);
        status.textContent = 'E-Mail-Adresse kopiert.';
      } catch {
        status.textContent = 'E-Mail-Adresse: ' + address;
      }
    });
  });
})();
